// removed by extract-text-webpack-plugin
module.exports = {"speed_row":"speed_row","speed_row_progress":"speed_row_progress","speed_row_header":"speed_row_header","dark":"dark","ant-progress-inner":"ant-progress-inner"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/SpeedInfoRow/style.scss
// module id = 1356
// module chunks = 0